<template>
<div class="animated fadeIn" v-if="building">
  <b-card>
    <b-button-toolbar class="pull-right">
      <b-btn variant="primary" @click="showAddFloor">Add Floor</b-btn>
    </b-button-toolbar>
  </b-card>

  <b-card :title="'Building: '+building.name">
    <v-client-table :data="floors" :columns="columns" :options="options" :theme="theme" id="dataTable" ref="dataTable">
      <template slot="actions" slot-scope="data">
        <b-button class="mr-1" size="sm" variant="primary" @click="showEditModal(data.row)"><i class="fa fa-pencil"></i></b-button>
        <b-button class="mr-1" size="sm" variant="primary" @click="showSetAttributeModal(data.row)">Set Attributes</b-button>
        <b-button size="sm" variant="primary" :to="{name: 'Rooms', params: {building_id: data.row.building.id, floor_id: data.row.id}}">Manage Rooms</b-button>
      </template>
      <template slot="attributes" slot-scope="data">
        <ul>
          <li v-for="atrribute in data.row.attributes">
            {{ atrribute.name }}: {{ atrribute.value }}
          </li>
        </ul>
      </template>
    </v-client-table>
  </b-card>

  <div>
    <b-modal ref="modalAddFloor" title="Add Floor" hide-footer @hide="hideAddFloor" no-enforce-focus>
      <floor-form-add v-if="canShowAddFloor" @success="addFloorSuccess" @cancel="cancelAddFloor" />
    </b-modal>
    <b-modal ref="modalEditFloor" title="Edit Floor" hide-footer @hide="hideEditFloor" no-enforce-focus>
      <floor-form-edit v-if="selectedFloor" :floor="selectedFloor" @success="editFloorSuccess" @cancel="cancelEditFloor" />
    </b-modal>
    <b-modal ref="modalSetAttributes" title="Set Attributes" hide-footer @hide="hideSetAttributes" no-enforce-focus>
      <set-attributes v-if="selectedSetAttributes" :object="selectedSetAttributes" type="FLOOR" @success="setAttributeSuccess" @cancel="hideSetAttributes" />
    </b-modal>
  </div>
</div>

</template>

<script>
import { mapState } from 'vuex'
import Vue from 'vue'
import FloorFormAdd from './FloorFormAdd'
import FloorFormEdit from './FloorFormEdit'
import SetAttributes from './SetAttributes'

export default {
  name: 'FloorList',
  components: {
    FloorFormAdd,
    FloorFormEdit,
    SetAttributes
  },
  computed: mapState({
    floors: state => state.floors.all,
  }),
  data: function() {
    return {
      building: null,
      columns: [
        'floor_number',
        'position',
        'total_rooms',
        'attributes',
        'actions'
      ],
      options: {
        headings: {
          'floor_number': 'Floor Number',
          'position': 'Stair Position',
          'total_rooms': 'Rooms',
          'attributes': 'Atrributes',
          'actions': 'Actions'
        },
        sortable: [],
        filterable: [],
        sortIcon: {
          base: 'fa',
          up: 'fa-sort-asc',
          down: 'fa-sort-desc',
          is: 'fa-sort'
        },
        pagination: {
          chunk: 5,
          edge: true,
          nav: 'scroll'
        },
        perPage: 25,
      },
      useVuex: false,
      theme: 'bootstrap4',
      template: 'default',
      canShowAddFloor: false,
      selectedFloor: null,
      selectedSetAttributes: null
    }
  },
  methods: {
    showAddFloor() {
      this.canShowAddFloor = true
      this.$refs.modalAddFloor.show()
    },
    cancelAddFloor() {
      this.$refs.modalAddFloor.hide()
    },
    addFloorSuccess() {
      this.$refs.modalAddFloor.hide()
      this.refresh()
    },
    hideAddFloor() {
      this.canShowAddFloor = false
    },
    showEditModal(building) {
      this.selectedFloor = building
      this.$refs.modalEditFloor.show()
    },
    editFloorSuccess() {
      this.$refs.modalEditFloor.hide()
      this.refresh()
    },
    cancelEditFloor() {
      this.$refs.modalEditFloor.hide()
    },
    hideEditFloor() {
      this.selectedFloor= null
    },
    showFloorModal(building) {
      this.selectedFloor = building
      this.$refs.modalFloors.show()
    },
    showSetAttributeModal(room) {
      this.selectedSetAttributes = room
      this.$refs.modalSetAttributes.show()
    },
    setAttributeSuccess() {
      this.hideSetAttributes()
      this.refresh()
    },
    hideSetAttributes() {
      this.selectedSetAttributes = null
      this.$refs.modalSetAttributes.hide()
    },
    refresh() {
      this.$store.dispatch('floors/getFloors', {id: this.$route.params.id})
    }
  },
  created () {
    this.refresh()
    this.$store.dispatch('buildings/getBuilding', {id: this.$route.params.id})
    .then((response) => {
      this.building = response.data.data
    })
    this.$store.dispatch('attributes/getAttributes')
  }
}
</script>
